"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityReferenceFieldMultiple = exports.entityReferenceField = void 0;
var react_1 = __importDefault(require("react"));
var pluralize_1 = require("pluralize");
var sprintf_js_1 = require("sprintf-js");
var input_entity_reference_1 = require("../components/forms/input-entity-reference");
var entity_field_1 = require("./entity-field");
var title_case_1 = require("./title-case");
var entityReferenceField = function (args) {
  var name = args.name,
    placeholder = args.placeholder,
    required = args.required,
    label = args.label,
    description = args.description,
    context = args.context,
    isAvailable = args.isAvailable,
    loadOptionsFilter = args.loadOptionsFilter,
    _a = args.fieldSet,
    fieldSet = _a === void 0 ? 'overview' : _a;
  var isMulti = args.isMulti === undefined ? (0, pluralize_1.isPlural)(name) : args.isMulti;
  var t = context.t,
    definition = context.definition;
  var defaultMultiLabel = (0, sprintf_js_1.sprintf)(t("Reference items against this %s"), definition.label);
  var defaultLabel = (0, sprintf_js_1.sprintf)(t("Reference an item against this %s"), definition.label);
  return __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    placeholder: placeholder && t(placeholder) || (isMulti ? (0, sprintf_js_1.sprintf)(t("Find one or more items")) : (0, sprintf_js_1.sprintf)(t("Find an item"))),
    label: label || (0, title_case_1.titleCase)(name),
    description: description && t(description) || (isMulti ? defaultMultiLabel : defaultLabel),
    render: function (props) {
      return react_1.default.createElement(input_entity_reference_1.InputEntityReference, __assign({}, props, {
        isClearable: true,
        isMulti: isMulti,
        loadOptionsFilter: loadOptionsFilter,
        context: context
      }));
    }
  });
};
exports.entityReferenceField = entityReferenceField;
var entityReferenceFieldMultiple = function (args) {
  return (0, exports.entityReferenceField)(__assign(__assign({}, args), {
    isMulti: true
  }));
};
exports.entityReferenceFieldMultiple = entityReferenceFieldMultiple;